import React, { useEffect, useState } from "react";
import styles from "./Modal.module.css";
import axios from "../../services/axiosInstance";
import { toast } from "react-toastify";
import { SquareX, CircleCheckBig } from "lucide-react";

const ModalVincularComissoes = ({ pautaId, onClose, onSaved }) => {
  const [loading, setLoading] = useState(true);
  const [comissoes, setComissoes] = useState([]);
  const [selecionadas, setSelecionadas] = useState(new Set());

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const [all, vincs] = await Promise.all([
          axios.get("/comissoes"),
          axios.get(`/pautas/${pautaId}`),
        ]);
        const todas = all.data || [];
        setComissoes(todas);

        // marcar as já vinculadas
        const jaVinc = new Set(
          (vincs?.data?.comissoesRelacionadas || [])
            .map((rel) => rel?.comissao?.id || rel?.comissaoId || rel?.id)
            .filter(Boolean)
        );
        setSelecionadas(jaVinc);
      } catch {
        toast.error("Erro ao carregar comissões.");
      } finally {
        setLoading(false);
      }
    })();
  }, [pautaId]);

  const toggle = (id) => {
    setSelecionadas((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const salvar = async () => {
    try {
      // ajuste o endpoint conforme seu backend
      await axios.post(`/pautas/${pautaId}/vincular-comissoes`, {
        comissaoIds: Array.from(selecionadas),
      });
      // opcional: emitir evento de tramitação/status "enviado à comissão" no back
      toast.success("Comissões vinculadas.");
      onSaved?.();
    } catch {
      toast.error("Falha ao vincular comissões.");
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()} style={{ maxWidth: 720, height: "auto" }}>
        <button className={styles.modalClose} onClick={onClose}>
          <SquareX />
        </button>
        <h2 className={styles.modalTitle}>Vincular Comissões</h2>

        {loading ? (
          <div className={styles.loading}>Carregando...</div>
        ) : (
          <div className={styles.modalContentScrollable}>
            <ul className={styles.listaBlocoMaterias}>
              {comissoes.map((c) => (
                <li key={c.id} style={{ padding: 6 }}>
                  <label style={{ display: "flex", alignItems: "center", gap: 10, width: "100%" }}>
                    <input style={{width: "auto"}}
                      type="checkbox"
                      checked={selecionadas.has(c.id)}
                      onChange={() => toggle(c.id)}
                    />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <strong>{c.nome || `Comissão ${c.id}`}</strong>
                      <small className={styles.noneMuted}>
                        {c.sigla ? `(${c.sigla})` : "Sem sigla"}
                      </small>
                    </div>
                  </label>
                </li>
              ))}
            </ul>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
              <button className={styles.uploadButton} onClick={salvar}>
                Salvar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalVincularComissoes;
